import type { RouteConfig } from '@his/shared';
import ActivitiesShell from '@/pages/activities';
import ActivitiesPage from '@/pages/activities/list';
import ActivityDetailShell from '@/pages/activities/detail';
import ActivityDetailPage from '@/pages/activities/detail/overview';
import LotteryRulesPage from '@/pages/activities/detail/lottery-rules';
import ActivityStatsPage from '@/pages/activities/detail/stats';
import ActivityPostersPage from '@/pages/activities/detail/posters';
import MyInvitationsPage from '@/pages/activities/detail/my-invitations';
import MePage from '@/pages/me/MePage';
import EditProfilePage from '@/pages/me/EditProfilePage';
import OlympicGuessPage from '@/pages/activities/items/olympic';
import FcbBayernActivityPage from '@/pages/activities/items/fcb';
import FcbBayernActivitySecondPage from '@/pages/activities/items/fcb-second';

/**
 * Mobile 应用路由配置
 *
 * 特性：
 * - 使用 meta.requiresAuth 声明是否需要认证
 * - 路由层只做认证检查，不做权限检查
 * - 页面内的权限控制使用 PermissionGuard 或 usePermission
 * - ✅ 统一登录：未登录时通过 RouteGuard 自动跳转到 home 模块的登录页
 * - `/activities` 下为嵌套子路由（与业务「活动模块」一致），对外 URL 不变
 */
export const mobileRoutes: RouteConfig[] = [
  {
    path: '/activities',
    element: <ActivitiesShell />,
    /** 壳层不拦截登录；各子路由单独声明 requiresAuth */
    meta: { requiresAuth: false },
    children: [
      {
        index: true,
        path: '',
        element: <ActivitiesPage />,
        meta: {
          title: '活动',
          requiresAuth: true,
        },
      },
      {
        path: 'items/olympic',
        element: <OlympicGuessPage />,
        meta: {
          title: '看冬奥，猜金牌，赢豪礼',
          requiresAuth: false,
        },
      },
      {
        path: 'items/fcb',
        element: <FcbBayernActivityPage />,
        meta: {
          title: '共赴拜仁之战',
          requiresAuth: false,
        },
      },
      {
        path: 'items/fcb-second',
        element: <FcbBayernActivitySecondPage />,
        meta: {
          title: '共赴拜仁之战',
          requiresAuth: false,
        },
      },
      {
        path: ':id',
        element: <ActivityDetailShell />,
        meta: { requiresAuth: false },
        children: [
          {
            index: true,
            path: '',
            element: <ActivityDetailPage />,
            meta: {
              title: '活动详情',
              requiresAuth: true,
            },
          },
          {
            path: 'lottery-rules',
            element: <LotteryRulesPage />,
            meta: {
              title: '抽奖安排',
              requiresAuth: true,
            },
          },
          {
            path: 'stats',
            element: <ActivityStatsPage />,
            meta: {
              title: '活动统计',
              requiresAuth: true,
            },
          },
          {
            path: 'my-invitations',
            element: <MyInvitationsPage />,
            meta: {
              title: '我的邀请',
              requiresAuth: true,
            },
          },
          {
            path: 'posters',
            element: <ActivityPostersPage />,
            meta: {
              title: '活动海报',
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/me',
    element: <MePage />,
    meta: {
      title: '我的',
      requiresAuth: true,
    },
  },
  {
    path: '/me/edit',
    element: <EditProfilePage />,
    meta: {
      title: '编辑资料',
      requiresAuth: true,
    },
  },
];
